export class Constantes {
  static readonly noMessageConsultationDelaiDepasse = "90";
  static readonly noMessageOperationImpossible = "91";

  static Roles = class {
    static readonly RU_ACTIV_ROLE_IDZ = "RU_ACTIV_ROLE_IDZ";
    static readonly RU_CLIENT_SIG = "RU_CLIENT_SIG";
    static readonly RU_ACCES_INTRA_SIG = "RU_ACCES_INTRA_SIG";
    static readonly Pilote = 'RU_PILOTE_SIG';
    static readonly RU_GESTI_TERRI_PUBLI_SIG = 'RU_GESTI_TERRI_PUBLI_SIG';
  };

  static Profiles = class {
    static readonly DG_TERRITOIRE_PUBLIC = 'DG TERRITOIRE PUBLIC'
  }

  static Parametres = class {
    static readonly BandeauMessageAccueil = 'BANDEAU_MSG_ACCUEIL';
    static readonly BandeauMessageAccueilLongueurMax = 200;
  };

  static TypeUtilisateur = class {
    static readonly Interne = 'i';
    static readonly Externe = 'p';
  };

  static readonly regexValidationCommentaire = /^[a-zA-ZÀ-Ÿ0-9 \p{P}][^@#\\\/]*$/gmu;

  static MessageApplicatif = class {
    static readonly ValeurObligatoire_1E = "Valeur obligatoire : {0}.";
    static readonly Invalide_2E = "{0} est invalide.";
    static readonly Existe_3E = "{0} : {1} existe déjà dans le système.";
    static readonly Introuvable_4E = "{0}: {1} est introuvable.";
    static readonly AuMinsElementFournis_5E = "Au moins {0} doit être fourni.";
    static readonly AucunElement_6I = "Aucun élément trouvé.";
    static readonly ElementEnregistrer_7I = "Les informations ont été enregistrées avec succès.";
    static readonly ElementSuperieurAautre_8E = "{0} doit être supérieure {1}.";
    static readonly SupprimerElement_9A = "Voulez-vous vraiment supprimer {0} ?";
    static readonly QuitterPage_10A = "Si vous quittez cette page, vous perdrez les modifications apportées à la saisie des données. " +
      "Voulez-vous vraiment quitter la page ?";
    static readonly OperationNonComplete_11E = "Cette opération ne peut pas être complétée.";
    static readonly AccesRefuse_12E = "Accès refusé.";
    static readonly InferieurDateJour_13E = "La date {0} doit être inférieure ou égale à la date du jour.";
    static readonly SuperieurDateJour_14E = "La date {0} doit être supérieure ou égale à la date du jour.";
    static readonly DateFinSuperieurDateDebut_15E = "La date de fin {0} doit être supérieure ou égale à la date de début.";
    static readonly CoucheIndisponible_16T = "Certaines couches ne sont pas disponibles pour des raisons techniques, " +
      "Veuillez essayer plus tard ou écrire au support technique.";
    static readonly CommentaireAuMoins10_20E = "Le commentaire doit contenir au moins 10 caractères.";
    static readonly CompriseRayon_21A = "Le rayon doit être compris entre 0 et 100 kilomètres (ou 100 000 mètres).";
    static readonly Information_22E = "Vous devez {0}";
    static readonly MaximumCaracteres_28E = "Maximum de {0} caractères.";
    static readonly Avertissement_29A = "AVERTISSEMENT: Nombre de résultats limité à {0}, veuillez réduire votre zone de recherche.";

  };
}
